export const AGENT_REGISTRATION = 'https://agents.pulse.insure/auth?tab=1';
export const RGS_CAREER = 'https://www.rgs.ru/about/career/stat-agentom';
